import { createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile } from 'firebase/auth';
import React, { createContext, useEffect, useState } from 'react';
import app from '../../Firebase/Firebase.config';
  



export const AuthContext = createContext();
const auth = getAuth(app);
const AuthProvider = ({children}) => {
    
    const [user, setUser]= useState({});
    const [loading,setLoading] = useState(true);

   

useEffect(()=>{
    const unsubscribe = onAuthStateChanged(auth,(currentUser)=>{
        setUser(currentUser);
        setLoading(false);
        if(user){
            const uid = currentUser.uid;
            const displayName = currentUser.displayName;
            const photoUrl = currentUser.photoURL;

        }
    })
    return ()=>{
        unsubscribe();
    }
},[])

const profileUpdate=(fullName,PhotoUrl)=>{
   return updateProfile(auth.currentUser, {
        displayName: fullName, photoURL: PhotoUrl
      })
}


    // const googleProvider = new GoogleAuthProvider()
    const googleProvider = new GoogleAuthProvider();
    const providerSignIn = ()=>{
        setLoading(true);
        return signInWithPopup(auth,googleProvider);
    }

    const userSignUp=(email,password)=>{
        setLoading(true);
        return createUserWithEmailAndPassword(auth,email,password);
    }
    const userLogin = (email,password)=>{
        setLoading(true);
        return signInWithEmailAndPassword(auth,email,password);
    }
    const userSignOut = ()=>{
        setLoading(true);
        return signOut(auth);
    }
   
    const authInfo = {user, loading, setLoading, providerSignIn,userLogin,userSignUp,userSignOut,profileUpdate}
    return (
        <div>
            <AuthContext.Provider value={authInfo}>
                {children}
            </AuthContext.Provider>
        </div>
    );
};

export default AuthProvider;